module.exports = __webpack_public_path__ + "img/gmail.e25685a2.svg";